import { Editor } from "tinymce";
import { ajaxRequest } from "../../Utils/Ajax/ajax";
import { ajaxSpin, errorToast, hideModal } from "../../Utils/utils";

export function uniqueRandomId(length){
    let result           = '';
    const characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() *
            charactersLength));
    }
    return result;
}

export function generateId(inputId=0){
    const aufgabeId = getAufgabeId();
    if (aufgabeId == 0){
        return dateId();
    } else {
        return `${aufgabeId}_${inputId}`;
    }
}

export function dateId(){
    return new Date().valueOf();
}

export function getModalInputId(modal){
    return modal.find(".sub").attr('data-id');
}

export function insertData(data:Object, editor:Editor, command:string, modalId:string){
    if ( data.id > 0){
        editor.execCommand(command, data)
        return true;
    } else {
        insertNewInput(editor, command, data, modalId);
        return false;
    }
}

export function getAufgabeId(){
    return $("#aufgabe-id").val();
}

export function insertNewInput(editor:Editor, command:string, inputData, modalId:string){

    const url = '/input/create'
    const data = {
        taskId: getAufgabeId()
    }

    const success = function (data){
    }

    ajaxRequest(url, success, data, $($(".sub")[0])).done((data) => {
        inputData.id = data.id;
        editor.execCommand(command, inputData)
        hideModal(modalId);
    })

}